import React from 'react';
import { Container, Row } from 'react-bootstrap';
import project1 from '../../images/project1.png';
import project2 from '../../images/project2.png';
import project3 from '../../images/project3.png';
import project4 from '../../images/project4.png';
import project5 from '../../images/project5.gif';
import project6 from '../../images/project6.png';
import project7 from '../../images/project7.jpeg';
import './Projects.css'
import Project from '../Project/Project';



const projects = [
    {
        name: "BREVEMOD. - Hack Melbourne 2022",
        img: project1,
        id: 1,
        details: `BREVEMOD is made up of two parts: BREVE and MOD. "BREVE" is a Latin term for "short," and "MOD" is derived from the word "modules." Overall, BREVEMOD demonstrates short modules. BREVEMOD focuses on two major things: daily learning and creating urgency for the students to make them persistent.`
    },
    {
        name: "CarSales - Full Stack Application",
        img: project2,
        id: 2,
        details: "This is a simple niche application where cars are displayed and users can book them. The application has a User Dashboard Profile system along with an Admin Panel."
    },
    {
        name: "Udemy - Full Stack Application",
        img: project3,
        id: 3,
        details: "An application where users can create an account or login with an existing account and can look for their desired courses and add them to their cart for purchase."
    },
    {
        name: "React Native Mobile App",
        img: project4,
        id: 4,
        details: "This is a simple React Native app which shows live Covid information of the world using API."
    },
    {
        name: "BYOCC - Hackathon Project 2021",
        img: project5,
        id: 5,
        details: "I got Second Place and Best UI Design Award for developing an application that leads to sustainability within 24 hours."
    },
    {
        name: "Ambulance Service",
        img: project6,
        id: 6,
        details: "An application which makes Ambulance Service more reachable to people easily. Users can choose different service and book them with details."
    }
]
const Projects = () => {
    return (
        <div id="projects" className="pt-5" style={{ overflow: 'hidden' }} >
            <div data-aos="fade-up">
                <div className="my-5 text-white">
                    <h2 className="fw-bold">My Recent Work</h2>
                    <p>Here are a few development projects I've worked on recently. Want to see more? <a className="text-decoration-none" href="mailto:shadmansaalim321@gmail.com">Email me</a>.
                    </p>
                </div>
                <Container>
                    <Row xs={1} md={2} lg={3} className="g-4">
                        {projects.map(project => <Project
                            key={project.id}
                            project={project}
                        ></Project>)
                        }
                    </Row>
                </Container>
            </div>
        </div >
    );
};

export default Projects;